import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api.service';
import { SubscriptionService } from 'src/app/shared/services/subscription.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { LimitWordsPipe } from 'src/app/theme/pipes/word_limit.pipe'; 
import { of, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SharedDataService } from 'src/app/shared/services/sharedata.service';
@Component({
  selector: 'app-vendors',
  templateUrl: './vendors.component.html',
  styleUrls: ['./vendors.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom,
  providers: [LimitWordsPipe]
})
export class VendorsComponent implements OnInit, OnDestroy {
  public vendors = [];
  public vendor = [];
  featureTags = {} ; 
  private destroy$ = new Subject<void>();

  constructor(
    private apiService: ApiService,
    public router: Router,
    private subscriptionService: SubscriptionService,
    private sanitizer: DomSanitizer,
    private limitWordsPipe: LimitWordsPipe,
    public sharedDataService: SharedDataService
  ) { }

  ngOnInit(): void {
    this.featureTags = JSON.parse(sessionStorage.getItem("featureTags")); 

    this.apiService.getVendor()
    .pipe(takeUntil(this.destroy$))
    .subscribe(result => {
      if(result['response']['status'] === 1) {
        let vendorList = result['response']['data']['vendor_list'];
        if(!!this.featureTags && this.featureTags['sf_vendor_page']){
          if(!!this.featureTags && this.featureTags['sf_vendor_page_2']){
            vendorList = vendorList.sort((a, b) => a.vendor_name.localeCompare(b.vendor_name));
            this.vendors = vendorList.map(vendor => {
              const limitedText = this.limitWordsPipe.transform(vendor['vendor_description']);
              return {
                ...vendor,
                sanitizedDescription: this.sanitizer.bypassSecurityTrustHtml(vendor['vendor_description'])
              };
            });
          }else{
            this.vendors = result['response']['data']['vendor_list'].sort((a, b) => {
              return a.vendor_name.localeCompare(b.vendor_name);
            });
          }
        }else{
          this.vendors = result['response']['data']['vendor_list'];
        }        
      }
    }, (error) => {
      console.log(error);
      return of(null); // In SSR, Prevent memory leaks by returning a safe value
    });

    if(!!this.featureTags && this.featureTags['sf_header_cart_count']){
      this.sharedDataService.cartResponse$.pipe(
        takeUntil(this.destroy$)
      ).subscribe(res => {        
        this.getCartCount();
      });      
    }
  }

  vendorSelection(vendor){
    this.setSelectedVendorValue(vendor['id']);    
    localStorage.setItem('chkload',JSON.stringify(true))

    // if (this.featureTags && this.featureTags["remove_vendor_code_in_url"]) {

      // this.router.navigate(
      //   ['/vendors', vendor['vendor_url'] ],
      //   { state: { vendor_id : vendor['id'] } });
    let urlvendor="/vendors/"+vendor['vendor_url'];
    if (!!this.featureTags && this.featureTags['ftag_sf_manufacturer_list']) {
      urlvendor="/producers/"+vendor['vendor_url'];
    }
    return urlvendor;
    // }else{
    //   // this.router.navigate(['/vendors', vendor['vendor_name'].replace(/[\s&/]+/g, '_'), vendor['id']])
    //   let urlvendor="/vendors/"+vendor['vendor_name'].replace(/[\s&/]+/g, '_') + "/"+ vendor['id'];
    //   return urlvendor;
    // }
  
    this.subscriptionService.subjectNext({ vendorName: vendor['vendor_name'], vendors: this.vendor });
  }
  
  setSelectedVendorValue(value) {
    this.vendor.forEach(x => { x.selected = x.id !== value ? false : true });

  }

  getCartCount() {
    if (this.apiService.loggedIn()) {
      this.sharedDataService.getOrderData();
    }
  }

  ngOnDestroy(): void {    
    this.destroy$.next();
    this.destroy$.complete();
  }
}
